import { EnumerationDto } from '@/api/backoffice/clients';

export const ENUM_StatusTypes = {
    Draft: createEnumValue(0, 'Draft'),
    Actief: createEnumValue(1, 'Actief'),
    NietActief: createEnumValue(2, 'Niet-actief'),
    Gearchiveerd: createEnumValue(3, 'Gearchiveerd')
};

export const ENUM_ContextTypes = {
    Delivery: createEnumValue(0, 'Delivery'),
    Operation: createEnumValue(1, 'Operation'),
    Source: createEnumValue(2, 'Source'),
    Product: createEnumValue(3, 'Product')
};

export const ENUM_EntityTypes = {
    Point: createEnumValue(0, 'Point'),
    LineString: createEnumValue(1, 'LineString'),
    Polygon: createEnumValue(2, 'Polygon'),
    GeometryCollection: createEnumValue(3, 'GeometryCollection'),
    MultiPoint: createEnumValue(4, 'MultiPoint'),
    MultiLineString: createEnumValue(5, 'MultiLineString'),
    MultiPolygon: createEnumValue(6, 'MultiPolygon'),
    CodeList: createEnumValue(7, 'CodeList'),
    Table: createEnumValue(8, 'Table')
};

export const ENUM_DataTypes = {
    Tekst: createEnumValue(1, 'Tekst'),
    Getal: createEnumValue(2, 'Getal'),
    Vlag: createEnumValue(3, 'Vlag'),
    Datum: createEnumValue(4, 'Datum'),
    DatumEnTijd: createEnumValue(5, 'Datum + tijd')
};

export const ENUM_SridTypes = {
    Etrs89: createEnumValue(4258, 'Etrs89'),
    Wgs84: createEnumValue(4326, 'Wgs84'),
    Lambert72: createEnumValue(31370, 'Lambert72'),
    WebMercator: createEnumValue(3857, 'WebMercator'),
    Lambert2008: createEnumValue(3812, 'Lambert2008')
};

export const ENUM_TransformationTypes = {
    EntiteitMapping: createEnumValue(1, 'Entiteit mapping'),
    AttribuutMapping: createEnumValue(2, 'Attribuut mapping'),
    AttribuutLookup: createEnumValue(3, 'Attribuut lookup'),
    GeometrieNaarAdres: createEnumValue(4, 'Geometrie naar adres'),
    AdresNaarAdres: createEnumValue(5, 'Adres naar adres'),
    AdresNaarGeometrie: createEnumValue(6, 'Adres naar geometrie'),
    Voorbewerking: createEnumValue(7, 'Voorbewerking'),
    Tussenbewerking: createEnumValue(8, 'Tussenbewerking'),
    Nabewerking: createEnumValue(9, 'Nabewerking'),
    SqlUitvoering: createEnumValue(10, 'Sql uitvoering')
};

export const ENUM_TriggerTypes = {
    LeveringTrigger: createEnumValue(1, 'Levering trigger'),
    ProductTrigger: createEnumValue(2, 'Product trigger'),
    TijdTrigger: createEnumValue(3, 'Tijd trigger')
};

export const ENUM_TimeTriggerTypes = {
    Levering: createEnumValue(1, 'Levering'),
    Product: createEnumValue(2, 'Product'),
    SwitchJob: createEnumValue(3, 'SwitchJob'),
    ProductExportRunCleanupJob: createEnumValue(4, 'ProductExportRunCleanupJob')
};

export const ENUM_DeliveryProductTriggerTypes = {
    Levering: createEnumValue(1, 'Levering'),
    Product: createEnumValue(2, 'Product')
};

export const ENUM_TriggerSources = {
    Databank: createEnumValue(1, 'Databank'),
    Cloudopslag: createEnumValue(2, 'Cloudopslag'),
    FTPServer: createEnumValue(3, 'FTP server'),
    Webservice: createEnumValue(4, 'Webservice'),
    Website: createEnumValue(5, 'Website')
};

export const ENUM_GeckoSpecificationStates = {
    None: createEnumValue(0, 'Geen'),
    Draft: createEnumValue(1, 'Draft'),
    ValidatedDraft: createEnumValue(2, 'ValidatedDraft'),
    Active: createEnumValue(3, 'Active'),
    Archived: createEnumValue(4, 'Archived'),
    Removed: createEnumValue(45, 'Removed')
};

export const ENUM_DeliveryQualityCheckTypes = {
    Basistesten: createEnumValue(0, 'Basistesten'),
    Standaardtesten: createEnumValue(1, 'Standaardtesten')
};

function createEnumValue(id: number, name: string): EnumerationDto {
    return { id, name };
}
